import { ConCludeBorrowContainer } from "../../../containers/borrowSystem/Report/ConCludeBorrowContainer";

export function ConCludeBorrowPage() {
    return (
        <ConCludeBorrowContainer />
    )
}